import { useMemo } from 'react';

const group = (list, keyGetter) => {
  const values = new Set();
  list.forEach(item => {
    values.add(item[keyGetter]);
  });
  return [...values];
};

export const useLocationData = allSanityLocation => {
  const { towns, counties, locations } = useMemo(() => {
    const nodes = allSanityLocation.nodes.filter(location => !location.hidden);

    return {
      towns: group(nodes, 'town')
        .filter(town => town && town !== '')
        .map(town => {
          return {
            value: town,
            label: town,
          };
        })
        .sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }),
      counties: group(nodes, 'county')
        .filter(county => county && county !== '')
        .map(county => {
          return {
            value: county,
            label: county,
          };
        })
        .sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }),
      locations: nodes
        .map(location => {
          return {
            label: location.address,
            value: location.id,
          };
        })
        .sort((a, b) => {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        }),
    };
  }, [allSanityLocation]);
  return [towns, counties, locations];
};
